import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel,
    EuiSpacer
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/Portweiterleitung_bei_einem_TP_Link_Router_einrichten.mp4" />
        </Player>
        <EuiText>
            <p>Portweiterleitung bei einem TP-Link Router einrichten. Auf <OutboundLink href="https://www.youtube.com/watch?v=RAEox1Squ08" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
        <EuiSpacer size="xl" />
        <Player>
            <source src="https://wiki.instar.com/videos/Tutorial_Fernzugriff_per_Portweiterleitung_TP_Link.mp4" />
        </Player>
        <EuiText>
            <p>Portweiterleitung bei einem TP-Link Router einrichten.</p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard